import { createSelector } from "reselect";
import _, { get, compact, filter } from "lodash";

export const selectUsersRequesting = ({ Dashboard_reducer = false }) => {
    return Dashboard_reducer.requesting || null;
};
export const selectDateFrom = ({ Dashboard_reducer }) => {
    return Dashboard_reducer.dateFrom;
};
export const selectDateTo = ({ Dashboard_reducer }) => {
    return Dashboard_reducer.dateTo;
};
export const selectUsers = ({ Dashboard_reducer = false }) => {
    return Dashboard_reducer.users || null;
};
export const selectReportType = ({ Dashboard_reducer }) => {
    return Dashboard_reducer.report_type;
};
export const selectVehicles = ({ Dashboard_reducer }) => {
    if (
        typeof Dashboard_reducer.vehicleList !== "undefined" ||
        Dashboard_reducer.vehicleList !== null
    )
        return Dashboard_reducer.vehicleList;
    else return [];
};

export const selectReportTitles = ({ Dashboard_reducer }) => {
    return Dashboard_reducer.reportTitles;
};

export const selectTotalReports = ({ Dashboard_reducer }) => {
    return Dashboard_reducer.totalReports;
};
export const selectTotalUserReports = ({ Dashboard_reducer }) => {
    return Dashboard_reducer.totalReports;
};
export const selectTotalJobPackReports = ({ Dashboard_reducer }) => {
    return Dashboard_reducer.totalJobPackReports;
};
export const selectReportTypeForExcel = ({ Dashboard_reducer }) => {
    return Dashboard_reducer.excelReportType;
};
export const selectBuildingDocumentState = ({ Dashboard_reducer }) => {
    return Dashboard_reducer.buildingExcelDoc;
};
export const selectBuildingExcelDocumentState = createSelector(
    [selectBuildingDocumentState],
    buildingState => {
        return buildingState;
    }
);
export const selectReportDataForExcel = createSelector(
    [selectTotalUserReports, selectTotalJobPackReports, selectReportTypeForExcel],
    (userReports, jobPackReports, reportType) => {
        let totalReports = [];
        if (
            userReports === undefined ||
            userReports === false ||
            jobPackReports === undefined ||
            jobPackReports === false ||
            reportType === undefined ||
            reportType === false
        ) {
            return false;
        }
        let totalUserReports = getTotalReportsPerSubject(userReports, reportType);
        let totalJobPackReports = getTotalReportsPerSubject(jobPackReports, reportType);
        totalReports = totalUserReports.concat(totalJobPackReports);
        return totalReports;
    }
);

export const selectHolidayRequests = createSelector(
    [selectTotalReports],
    reports => {
        if (reports === false || reports === null || reports === undefined) {
            return undefined;
        }
        let holidayRequests = Object.keys(reports).map(e => {
            if (get(reports, `${e}.reports.holiday_request`) === undefined) {
                return null;
            }
            return {
                uid: e,
                reports: get(reports[e], "reports.holiday_request")
            };
        });

        holidayRequests = compact(holidayRequests);
        let approved = 0,
            denied = 0,
            pending = 0;
        holidayRequests.map(e => {
            Object.keys(e.reports).map(f => {
                if (e.reports[f].status === "Approved") approved++;
                else if (e.reports[f].status === "Denied") denied++;
                else pending++;
                return true;
            });

            return e;
        });
        let data = {
            labels: ["Approved", "Denied", "Pending"],
            datasets: [
                {
                    data: [approved, denied, pending],
                    backgroundColor: ["#36A2EB", "#FF6384", "#FFCE56"],
                    hoverBackgroundColor: ["#36A2EB", "#FF6384", "#FFCE56"]
                }
            ]
        };
        return data; // holidayRequests;
    }
);
export const selectReportsTotal = createSelector(
    [selectUsers, selectReportTitles],
    (allUsers, titles) => {
        let overall = 0;
        let reports;
        if (typeof titles !== "undefined" && typeof allUsers !== "undefined") {
            Object.keys(titles).map(key => {
                reports = Object.keys(allUsers).map(uid => {
                    let total = 0;
                    let report = get(allUsers, `${uid}.reports.${key}`);

                    if (typeof report !== "undefined") {
                        total = Object.keys(report).length;
                    } else total = 0;

                    return total;
                });
                reports = reports.reduce((a, b) => a + b, 0);

                //totalRep.push({title:titles[key], total:reports});
                overall += reports;
                return key;
            });
        } else return 0;
        return overall;
    }
);
export const allReportTotals = createSelector(
    [selectUsers, selectReportTitles, selectDateFrom, selectDateTo],
    (allUsers = false, titles = false, dateFrom = false, dateTo = false) => {
        if (dateTo === false) {
            dateTo = dateFrom;
        }
        let totalRep = [];
        if (allUsers && titles && dateFrom && dateTo) {
            Object.keys(titles).map(key => {
                let reports = Object.keys(allUsers).map(uid => {
                    let report = get(allUsers, `${uid}.reports.${key}`);
                    let filterReports = filterByDate(report, dateFrom, dateTo);
                    let total;
                    if (typeof filterReports !== "undefined") {
                        total = Object.keys(filterReports).length;
                    } else total = 0;

                    return total;
                });
                reports = reports.reduce((a, b) => a + b, 0);
                totalRep.push({ title: titles[key], total: reports });
                return key;
            });
        }

        return totalRep;
    }
);
export const allReportsForTable = createSelector(
    [selectUsers, selectReportTitles, selectDateFrom, selectDateTo],
    (allUsers = false, titles, dateFrom, dateTo) => {
        if (allUsers === false || allUsers === null) {
            return false;
        }
        let totalRep = [];
        if (typeof titles !== "undefined" && typeof allUsers !== "undefined") {
            Object.keys(allUsers).map(uid => {
                let reports = Object.keys(titles).map(key => {
                    let report = get(allUsers, `${uid}.reports.${key}`);
                    report = filterByDate(report, dateFrom, dateTo);
                    let total;
                    if (typeof report !== "undefined") {
                        total = Object.keys(report).length;
                    } else total = 0;

                    return total;
                });
                if (!(_.get(allUsers[uid], "profile.deleted") || false)) {
                    //reports = reports.reduce((a, b) => a + b, 0);
                    totalRep.push({
                        user: `${allUsers[uid].profile.first_name} ${
                            allUsers[uid].profile.last_name
                        }`,
                        total: reports
                    });
                    return uid;
                } else {
                    return null;
                }
            });
        }

        return _.compact(totalRep);
    }
);
export const selectBar = createSelector(
    [allReportTotals],
    userReports => {
        if (typeof userReports === "undefined")
            return {
                labels: ["Unknown"],
                datasets: [
                    {
                        label: "Reports Total",
                        data: [0],
                        backgroundColor: "rgba(63,81,181,0.2)",
                        borderColor: "rgba(63,81,181,1)",
                        borderWidth: 1,
                        hoverBackgroundColor: "rgba(63,81,181,0.4)",
                        hoverBorderColor: "rgba(63,81,181,1)"
                    }
                ]
            };

        let names = [],
            reports = [];
        if (typeof userReports !== "undefined") {
            Object.keys(userReports).map(n => {
                if (typeof userReports[n].title === "undefined") names.push("unknown");
                else names.push(userReports[n].title);

                if (typeof userReports[n].total === "undefined") reports.push(0);
                else reports.push(userReports[n].total);
                return n;
            });
        }
        let data = {
            labels: names,
            datasets: [
                {
                    label: "Reports Total",
                    data: reports,
                    backgroundColor: "rgba(63,81,181,0.2)",
                    borderColor: "rgba(63,81,181,1)",
                    borderWidth: 1,
                    hoverBackgroundColor: "rgba(63,81,181,0.4)",
                    hoverBorderColor: "rgba(63,81,181,1)"
                }
            ]
        };
        return data;
    }
);
export const selectDashDetail = createSelector(
    [selectUsers],
    (allUsers = false) => {
        if (allUsers === false || allUsers === null) {
            return false;
        }

        let emps = Object.keys(allUsers).length;
        let holTotal = 0,
            genTotal = 0;
        Object.keys(allUsers).map(uid => {
            let holreports = get(allUsers, `${uid}.reports.holiday_request`);
            let genreports = get(allUsers, `${uid}.reports.ppe_inspection`);
            if (typeof holreports !== "undefined") {
                holTotal += Object.keys(holreports).length;
            }
            if (typeof genreports !== "undefined") {
                genTotal += Object.keys(genreports).length;
            }
            return uid;
        });
        // Object.keys(holreports).map(i=>{
        //     holTotal +=i;
        // });
        // Object.keys(genreports).map(i=>{
        //     genTotal +=i;
        // });
        return {
            gen_total: genTotal,
            hol_total: holTotal,
            total_employees: emps
        };
    }
);
function getTotalReportsPerSubject(reports, reportType) {
    let totalReports = [];
    let totalReportsPerSubject = Object.keys(reports).map(uid => {
        return get(reports[uid], `reports.${reportType}`);
    });
    totalReportsPerSubject = compact(totalReportsPerSubject);
    totalReportsPerSubject.forEach(e => {
        let singleReports = Object.keys(e).map(f => {
            return e[f];
        });
        totalReports = totalReports.concat(singleReports);
    });
    return totalReports;
}

function filterByDate(orderedDailyReports, dateFrom, dateTo) {
    return filter(orderedDailyReports, e => {
        let dateParts = e.timestamp.split("-");
        let current = new Date(dateParts[2].split(" ", 1), dateParts[1] - 1, dateParts[0]);

        return current >= dateFrom && current <= dateTo;
    });
}
